var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobWraethShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #b1e1e5;\n      }\n\n      .cls-3 {\n        fill: aqua;\n      }\n\n      .cls-4 {\n        fill: #c9ecf2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "459.92 454.78 105.02 441.51 11.16 425.27 463.19 425.27 459.92 454.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "525.06 435.47 490.05 440.73 417.18 440.73 417.18 378.71 525.06 394.92 525.06 435.47"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "533.8 315.87 10.78 425.32 11.16 425.27 465.72 427.04 533.8 315.87"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "528.83 519.14 332.8 499.93 311.42 488.46 543.29 507.59 528.83 519.14"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "338.27 478.39 184.2 467.98 184.2 460.55 338.27 450.14 338.27 478.39"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "543.86 507.59 311.95 489 257.83 424.87 465.3 427.44 543.86 507.59"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.63 425.73 696.02 187.51 662.52 260.79 593.02 306.51 10.63 425.73"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.02 378.51 11.02 425.51 10.78 425.32 593.4 305.92 571.79 349.67 495.02 378.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobWraethShip);
export default __webpack_public_path__ + "static/media/mob-wraeth-ship.0067a9490eb3a105837e9419720b9896.svg";
export { ForwardRef as ReactComponent };